import { useState, memo } from "react";
import ValorDataCaixa from "./ValorDataCaixa";

import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "./ChequeTab.scss";

import moment from "moment";
import InputNumber from "../../../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../../../shared/components/inputs/InputText/InputText";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

function ChequeTab({
  valor,
  handleCloseModalReceber,
  receberHandler,
  totalPorReceber,
  caixas,
  parcela,
  cliente,
  modoContingenciaAtivo,
  parcelaTemFTE,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [numero, setNumero] = useState("");
  const [banco, setBanco] = useState("");
  const [dataCheque, setDataCheque] = useState(moment());
  const [nrConta, setNrConta] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [dadosValorDataCaixa, setDadosValorDataCaixa] = useState({
    valor: valor,
    data: moment(),
    caixa: caixas[0].id,
    observacao: "",
  });

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [pendingOperation, setPendingOperation] = useState(null);

  const changeValorDataCaixa = (data) => {
    setDadosValorDataCaixa(data);
  };

  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDialogConfirm = () => {
    setOpenConfirmDialog(false);
    setIsSubmitting(true);

    // Executar a operação pendente que foi armazenada
    if (pendingOperation) {
      receberHandler(
        {
          quantiaPaga: Number(dadosValorDataCaixa.valor),
          metodoPagamento: "Cheque",
          dataPagamento: dadosValorDataCaixa.data,
          caixa: dadosValorDataCaixa.caixa,
          parcelaPaga: dadosValorDataCaixa.valor === valor,
          quantiaPorPagar: valor - dadosValorDataCaixa.valor,
          observacao: dadosValorDataCaixa.observacao,
          nrCheque: numero,
          banco: banco,
          dataCheque: dataCheque,
          nrContaCliente: nrConta,
        },
        pendingOperation,
      );
    }
  };

  const preReceberHandler = (e, emitir) => {
    if (!isSubmitting) {
      //Validation
      let mensagemDeErro = "";
      if (
        !nrConta ||
        !numero ||
        !banco ||
        !dataCheque ||
        !dadosValorDataCaixa.caixa ||
        !dadosValorDataCaixa.valor
      ) {
        mensagemDeErro = "Preencha todos os campos";
        setErrorMessage(mensagemDeErro);
      }

      if (!dataCheque) {
        mensagemDeErro = "Introduza a data do cheque";
        setErrorMessage(mensagemDeErro);
      } else if (!moment.isMoment(dataCheque) || !dataCheque.isValid()) {
        mensagemDeErro = "Data do cheque inválida.";
      }

      if (!dadosValorDataCaixa.data) {
        mensagemDeErro = "Introduza a data de recebimento";
        setErrorMessage(mensagemDeErro);
      } else if (
        !moment.isMoment(dadosValorDataCaixa.data) ||
        !dadosValorDataCaixa.data.isValid()
      ) {
        mensagemDeErro = "Introduza a data de recebimento corretamente";
        setErrorMessage(mensagemDeErro);
      } else if (parcelaTemFTE && Number(dadosValorDataCaixa.valor) > valor) {
        // Parcela com FTE: não pode pagar mais que o valor da parcela
        // (o merge é bloqueado no backend; aqui damos a mensagem explicativa).
        mensagemDeErro = `Esta parcela tem uma FTE emitida. O valor a receber não pode exceder ${valor}$00.`;
        setErrorMessage(mensagemDeErro);
      }

      if (!mensagemDeErro && !isSubmitting) {
        if (emitir && cliente?.nome !== cliente?.nomeFiscal) {
          // Mostrar diálogo de confirmação
          // Guardar a operação pendente e mostrar o dialog
          setPendingOperation(emitir);
          setOpenConfirmDialog(true);
        } else {
          setIsSubmitting(true);
          receberHandler(
            {
              quantiaPaga: Number(dadosValorDataCaixa.valor),
              metodoPagamento: "Cheque",
              dataPagamento: dadosValorDataCaixa.data,
              caixa: dadosValorDataCaixa.caixa,
              parcelaPaga: dadosValorDataCaixa.valor === valor,
              quantiaPorPagar: valor - dadosValorDataCaixa.valor,
              observacao: dadosValorDataCaixa.observacao,
              nrCheque: numero,
              banco: banco,
              dataCheque: dataCheque,
              nrContaCliente: nrConta,
            },
            emitir,
          );
        }
      }
    }
  };

  const numeroChangeHandler = (value) => {
    setNumero(value);
  };

  const contaClienteChangeHandler = (value) => {
    setNrConta(value);
  };

  const bancoChangeHandler = (value) => {
    setBanco(value);
  };

  return (
    <div className="cheque__tab__container">
      <ValorDataCaixa
        valor={valor}
        changeValorDataCaixa={changeValorDataCaixa}
        caixas={caixas}
        totalPorReceber={totalPorReceber}
        tab="cheque"
      />
      <div className="cheque__tab__container__dados-cheque">
        <h2 className="cheque__tab__container__titulo">Dados do cheque</h2>
        <div className="cheque__tab__container__campos-cheque">
          <div className="cheque__tab__container__campos-cheque--1">
            <InputNumber
              key="numeroCheque"
              id="numeroCheque"
              initialValue={0}
              label="Número Cheque*"
              handleChange={numeroChangeHandler}
            />

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data*"
                inputFormat="DD-MM-YYYY"
                value={dataCheque}
                onChange={(value) => setDataCheque(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </div>
          <div className="cheque__tab__container__campos-cheque--2">
            <InputText
              initialValue={nrConta}
              label="Conta do cliente*"
              handleChange={contaClienteChangeHandler}
              notEmpty={true}
              id="contaDoCliente"
            />
            <InputText
              initialValue={banco}
              label="Banco*"
              handleChange={bancoChangeHandler}
              notEmpty={true}
              id="banco"
            />
          </div>
        </div>
      </div>
      {errorMessage && (
        <span className="fluxo-atendimento__modal__erros">{errorMessage}</span>
      )}
      <div className="fluxo-atendimento__modal__bottom_btns">
        <span
          className="cancel-btn"
          onClick={handleCloseModalReceber}
          style={{ display: "block" }}
        >
          Fechar
        </span>

        <span
          className="blue-button"
          disabled={isSubmitting}
          onClick={preReceberHandler}
        >
          {isSubmitting ? "Recebendo..." : "Receber"}
        </span>

        {!parcela.documentoEletronico &&
          !parcelaTemFTE &&
          (parcela.cancelamentosDocumentosEletronicos?.length === 0 ||
            (parcela.cancelamentosDocumentosEletronicos?.length > 0 &&
              parcela.cancelamentosDocumentosEletronicos[
                parcela.cancelamentosDocumentosEletronicos?.length - 1
              ]?.documentoCancelamento?.succeeded === true)) && (
            <span
              className="blue-button"
              disabled={isSubmitting}
              onClick={preReceberHandler.bind(null, null, "emitirFRE")}
            >
              {isSubmitting
                ? "Recebendo..."
                : `Receber e emitir FRE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          )}
      </div>
      {/* Dialog de confirmação */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({cliente?.nome}) e o nome fiscal (
            {cliente?.nomeFiscal}) são diferentes. Deseja prosseguir com a
            emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default memo(ChequeTab);
